import { gql } from "@apollo/client";

export const tosFragment = gql`
    fragment Tos on Tos {
        key
        metadata {
            latestVersion
            terms {
                key
                content
                sourceUrl
                effectiveDate
            }
        }
        acceptedVersion
    }
`;
